module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("1. Poseidon’s Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Isthmia and Its Games")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Paulos, Priscilla and Aquila")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Home of Erastos")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Enmity of the Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Gallio’s Gall")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Erastos Goes Missing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Proposition")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Trial of Paulos")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Julia’s Prayers and Nicanor’s Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Subura and the Sabbath")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Paulos, Priscilla and Erastos")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Dies Solis")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Afternoon of the Day of the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The End of the Day")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PostScriptum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post Scriptum")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/discussionQ",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ImagesandPermissions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Credits and Permissions")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praisefor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('em', [_vm._v("A Week in the Life of Corinth")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0